<template>
	<div>
		<div>Document ID</div>
		<CombinedInputFieldDataMenu class="mb-6" :textAreaMode="true" :value.sync="docsId" :valuesTypes="dataInputMenuValueTypes" />
		<div class="info-box">
			The feature user must have permission to edit the document. Tip: You can use the Drive action "Update file permissions".
		</div>
	</div>
</template>

<script>
import ItemOnlyAllowedValueTypesMixin from './ValueTypesMixins/ItemOnlyAllowedValueTypesMixin';
import FieldSettingsMixin, { getComputedMetadataOption } from '@/components/BlockEditorWidget/FieldSettings/FieldSettingsMixin';
import CombinedInputFieldDataMenu from '@/components/DataInput/CombinedInputFieldDataMenu';

export default {
	name: 'GoogleDocsFieldSettings',
	mixins: [FieldSettingsMixin, ItemOnlyAllowedValueTypesMixin],
	components: {
		CombinedInputFieldDataMenu,
	},
	computed: {
		docsId: getComputedMetadataOption('docs_id', 'value'),
	},
	data() {
		return {};
	},
	methods: {},
};
</script>

<style scoped>
div > .info-box {
	font-size: 12px;
	color: #646e87;
	background-color: #f9fafc;
	padding: 10px;
	border-radius: 5px;
	margin-top: 20px;
}
</style>
